import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../api/config"

const initialState = {
    isLoading: false,
    isLoadingDetail: false,
    isLoadingLogs: false,
    isSubmit: false,
    success: false,
    successAction: false,
    message: null,
    automacoes: [],
    automacao: null,
    logs: [],
    pagination: null,
    logsPagination: null
}

export const getAutomacoes = createAsyncThunk(
    'automacaoOperacao/getAutomacoes',
    async (params = {}, thunkAPI) => {
        try {
            const query = new URLSearchParams()
            if (params.page) query.set('page', params.page)
            if (params.limit) query.set('limit', params.limit)
            if (params.enabled !== undefined && params.enabled !== null && params.enabled !== '') {
                query.set('enabled', params.enabled)
            }
            const qs = query.toString()
            const res = await request(`automacao-operacao${qs ? `?${qs}` : ''}`)
            if (res.success === true || res.code === 200) {
                return {
                    data: res.data || [],
                    pagination: res.pagination || null
                }
            }
            return thunkAPI.rejectWithValue(res.message || 'Erro ao listar automações')
        } catch (e) {
            return thunkAPI.rejectWithValue(e?.response?.data?.message || 'Erro ao listar automações')
        }
    }
)

export const getAutomacao = createAsyncThunk(
    'automacaoOperacao/getAutomacao',
    async (values, thunkAPI) => {
        try {
            const query = new URLSearchParams()
            if (values.page) query.set('page', values.page)
            if (values.limit) query.set('limit', values.limit)
            const qs = query.toString()
            const res = await request(`automacao-operacao/${values.id}${qs ? `?${qs}` : ''}`)
            if (res.success === true || res.code === 200) {
                return res.data
            }
            return thunkAPI.rejectWithValue(res.message || 'Erro ao carregar automação')
        } catch (e) {
            return thunkAPI.rejectWithValue(e?.response?.data?.message || 'Erro ao carregar automação')
        }
    }
)

export const getAutomacaoLogs = createAsyncThunk(
    'automacaoOperacao/getAutomacaoLogs',
    async (values, thunkAPI) => {
        try {
            const query = new URLSearchParams()
            if (values.page) query.set('page', values.page)
            if (values.limit) query.set('limit', values.limit)
            if (values.status) query.set('status', values.status)
            const qs = query.toString()
            const res = await request(`automacao-operacao/${values.id}/logs${qs ? `?${qs}` : ''}`)
            if (res.success === true || res.code === 200) {
                return {
                    data: res.data || [],
                    pagination: res.pagination || null
                }
            }
            return thunkAPI.rejectWithValue(res.message || 'Erro ao carregar histórico')
        } catch (e) {
            return thunkAPI.rejectWithValue(e?.response?.data?.message || 'Erro ao carregar histórico')
        }
    }
)

export const createAutomacao = createAsyncThunk(
    'automacaoOperacao/createAutomacao',
    async (values, thunkAPI) => {
        try {
            const res = await request('automacao-operacao', 'POST', values)
            if (res.success === true || res.code === 200 || res.code === 201) {
                return res.data
            }
            return thunkAPI.rejectWithValue(res.message || 'Erro ao criar automação')
        } catch (e) {
            const data = e?.response?.data
            const msg = data?.errors?.length
                ? `${data.message}: ${data.errors.join('; ')}`
                : (data?.message || 'Erro ao criar automação')
            return thunkAPI.rejectWithValue(msg)
        }
    }
)

export const updateAutomacao = createAsyncThunk(
    'automacaoOperacao/updateAutomacao',
    async (values, thunkAPI) => {
        try {
            const { id, ...data } = values
            const res = await request(`automacao-operacao/${id}`, 'PATCH', data)
            if (res.success === true || res.code === 200) {
                return res.data
            }
            return thunkAPI.rejectWithValue(res.message || 'Erro ao atualizar automação')
        } catch (e) {
            const data = e?.response?.data
            const msg = data?.errors?.length
                ? `${data.message}: ${data.errors.join('; ')}`
                : (data?.message || 'Erro ao atualizar automação')
            return thunkAPI.rejectWithValue(msg)
        }
    }
)

export const deleteAutomacao = createAsyncThunk(
    'automacaoOperacao/deleteAutomacao',
    async (values, thunkAPI) => {
        try {
            const res = await request(`automacao-operacao/${values.id}`, 'DELETE')
            if (res.success === true || res.code === 200) {
                return values.id
            }
            return thunkAPI.rejectWithValue(res.message || 'Erro ao remover automação')
        } catch (e) {
            return thunkAPI.rejectWithValue(e?.response?.data?.message || 'Erro ao remover automação')
        }
    }
)

export const runAutomacao = createAsyncThunk(
    'automacaoOperacao/runAutomacao',
    async (values, thunkAPI) => {
        try {
            const res = await request(`automacao-operacao/${values.id}/run`, 'POST', {
                force: !!values.force
            })
            if (res.success === true) {
                return res.data || res
            }
            return thunkAPI.rejectWithValue(res.message || 'Erro ao executar automação')
        } catch (e) {
            return thunkAPI.rejectWithValue(e?.response?.data?.message || 'Erro ao executar automação')
        }
    }
)

const automacaoOperacaoSlice = createSlice({
    name: 'automacaoOperacao',
    initialState,
    reducers: {
        resetSuccessAction: (state) => {
            state.successAction = false
            state.message = null
        },
        resetErrorMessage: (state) => {
            state.message = null
        },
        clearAutomacao: (state) => {
            state.automacao = null
            state.logs = []
            state.logsPagination = null
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getAutomacoes.pending, (state) => {
                state.isLoading = true
                state.message = null
            })
            .addCase(getAutomacoes.fulfilled, (state, action) => {
                state.isLoading = false
                state.automacoes = action.payload.data
                state.pagination = action.payload.pagination
            })
            .addCase(getAutomacoes.rejected, (state, action) => {
                state.isLoading = false
                state.message = action.payload
            })

            .addCase(getAutomacao.pending, (state) => {
                state.isLoadingDetail = true
                state.message = null
            })
            .addCase(getAutomacao.fulfilled, (state, action) => {
                state.isLoadingDetail = false
                const { logs, logs_pagination, ...config } = action.payload || {}
                state.automacao = config
                state.logs = logs || []
                state.logsPagination = logs_pagination || null
            })
            .addCase(getAutomacao.rejected, (state, action) => {
                state.isLoadingDetail = false
                state.message = action.payload
            })

            .addCase(getAutomacaoLogs.pending, (state) => {
                state.isLoadingLogs = true
            })
            .addCase(getAutomacaoLogs.fulfilled, (state, action) => {
                state.isLoadingLogs = false
                state.logs = action.payload.data
                state.logsPagination = action.payload.pagination
            })
            .addCase(getAutomacaoLogs.rejected, (state, action) => {
                state.isLoadingLogs = false
                state.message = action.payload
            })

            .addCase(createAutomacao.pending, (state) => {
                state.isSubmit = true
                state.successAction = false
                state.message = null
            })
            .addCase(createAutomacao.fulfilled, (state, action) => {
                state.isSubmit = false
                state.successAction = true
                state.automacao = action.payload
            })
            .addCase(createAutomacao.rejected, (state, action) => {
                state.isSubmit = false
                state.successAction = false
                state.message = action.payload
            })

            .addCase(updateAutomacao.pending, (state) => {
                state.isSubmit = true
                state.successAction = false
                state.message = null
            })
            .addCase(updateAutomacao.fulfilled, (state, action) => {
                state.isSubmit = false
                state.successAction = true
                state.automacao = action.payload
            })
            .addCase(updateAutomacao.rejected, (state, action) => {
                state.isSubmit = false
                state.successAction = false
                state.message = action.payload
            })

            .addCase(deleteAutomacao.pending, (state) => {
                state.isSubmit = true
                state.successAction = false
                state.message = null
            })
            .addCase(deleteAutomacao.fulfilled, (state, action) => {
                state.isSubmit = false
                state.successAction = true
                state.automacoes = state.automacoes.filter((item) => item.id !== action.payload)
                state.automacao = null
            })
            .addCase(deleteAutomacao.rejected, (state, action) => {
                state.isSubmit = false
                state.successAction = false
                state.message = action.payload
            })

            .addCase(runAutomacao.pending, (state) => {
                state.isSubmit = true
            })
            .addCase(runAutomacao.fulfilled, (state) => {
                state.isSubmit = false
            })
            .addCase(runAutomacao.rejected, (state) => {
                state.isSubmit = false
            })
    }
})

export const { resetSuccessAction, resetErrorMessage, clearAutomacao } = automacaoOperacaoSlice.actions
export default automacaoOperacaoSlice.reducer
